<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <form @submit.prevent="updateUser">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0"><b>Editar Perfil</b></p>
                <argon-button type="submit" color="warning" size="sm" class="ms-auto">Guardar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Información de Usuario</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="email" class="form-control-label">Email</label>
                  <input id="email" class="form-control" type="email" disabled :value="userInfo.email" />
                </div>
                <div class="col-md-6">
                  <label for="personal-email" class="form-control-label">Email personal</label>
                  <input id="personal-email" class="form-control" type="email" :value="userInfo.personal_email" />
                </div>
                <div class="col-md-6">
                  <label for="name" class="form-control-label">Nombre</label>
                  <input id="name" class="form-control" type="text" :value="userInfo.name" />
                </div>
                <div class="col-md-6">
                  <label for="last-name" class="form-control-label">Apellido</label>
                  <input id="last-name" class="form-control" type="text" :value="userInfo.last_name" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Actualizar contraseña</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="new-pass" class="form-control-label">Nueva Contraseña</label>
                  <argon-input id="new-pass" type="password" />
                </div>
                <div class="col-md-6">
                  <label for="confirm-new-pass" class="form-control-label">Confirma Nueva Contraseña</label>
                  <argon-input id="confirm-new-pass" type="password" />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-4">
        <profile-card />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";

import ProfileCard from "./components/ProfileCard.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const userInfo = ref({});

// Función para obtener los datos de los proyectos
const fetchUserInfo = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/user-info`, {}, {
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en el header
      },
    });
    userInfo.value = response.data[0];
  } catch (error) {
    console.error('Error al obtener los datos del usuario:', error);
  }
};

const updateUser = async () => {
  const new_name = document.getElementById("name")?.value || "";
  const new_last_name = document.getElementById("last-name")?.value || "";
  const new_personal_email = document.getElementById("personal-email")?.value || "";
  // Obtener valores de los campos de contraseña
  const newPassword = document.getElementById("new-pass")?.value || "";
  const confirmNewPassword = document.getElementById("confirm-new-pass")?.value || "";

  // Validar si se ingresó una nueva contraseña
  if ((newPassword || confirmNewPassword) && newPassword !== confirmNewPassword) {
    alert("Las contraseñas no coinciden");
    return;
  }

  const data = {
    name: new_name,
    last_name: new_last_name,
    personal_email: new_personal_email,
  }
  // **Solo agregar la contraseña si se ingresó**
  if (newPassword && confirmNewPassword) {
    data.password = newPassword;
  }

  try {
    const response = await axios.post(`${API_BASE_URL}/update-self-user`, data, {
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en el header
      },
    });
    if (response.status == 200) {
      alert('Información Actualizada')
      window.location.reload();
    }
  } catch (error) {
    console.error('Error al obtener los datos del usuario:', error);
  }
}
onMounted(async () => {
  await fetchUserInfo();
});
</script>
